exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".popover{width:30%;max-width:100%!important;box-shadow:0 0 20px #333}.popover-title{font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-0ee733fe!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/History.vue
// module id = 189
// module chunks = 0